import { type FC, useEffect, useState } from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  toast
} from '@cencosud-cencommerce/paris-uikit';

import type { ISavedCardResponse } from '@/modules/perseo-billing/interfaces';
import { PickCardList } from '@/Pages/BuyNowPage/PaymentAndShipping/partials/PickCard';

interface PickCardProps {
  isOpen: boolean;
  onClose: () => void;
  loading?: boolean;
  savedCards: ISavedCardResponse[];
  currentSelectedToken: string | null;
  onSelectCard: (card: ISavedCardResponse) => void;
}

const LABEL_SELECT_BUTTON = 'Seleccionar';

const PickCardModal: FC<PickCardProps> = ({
  isOpen,
  onClose,
  loading,
  savedCards,
  currentSelectedToken,
  onSelectCard
}) => {
  const [selectedToken, setSelectedToken] = useState<string | null>(
    currentSelectedToken
  );

  useEffect(() => {
    setSelectedToken(currentSelectedToken);
  }, [currentSelectedToken]);

  const handleConfirm = async () => {
    if (!selectedToken) return;

    const selectedCardData = savedCards.find(
      (card) => card?.token === selectedToken
    );
    if (!selectedCardData) return;

    try {
      onSelectCard(selectedCardData);

      toast({
        title: '¡Listo! Cambiaste tu tarjeta',
        position: 'bottom-left',
        status: 'success'
      });
      onClose();
    } catch (err) {
      toast({
        title: 'No pudimos cambiar la tarjeta',
        position: 'bottom-left',
        status: 'error'
      });
    }
  };

  return (
    <Modal size="sm" isOpen={isOpen} onClose={onClose}>
      <ModalHeader
        icon={{
          name: 'il-payment-methods'
        }}
        className="[&_h3]:co-text-[0.875rem] tablet:[&_h3]:co-text-[1.25rem]"
        onClose={onClose}
        title="Elegir otra tarjeta"
      />
      <ModalBody className="co-flex co-flex-col co-gap-4 tablet:co-min-h-[244px]">
        <div className="co-flex co-flex-col co-h-500px">
          <div className="co-pt-[8px] co-h-500px">
            <PickCardList
              savedCards={savedCards}
              selectedToken={selectedToken}
              onChange={setSelectedToken}
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="co-flex co-flex-col-reverse tablet:co-flex-row co-justify-end co-gap-2 [&>*]:co-w-full tablet:[&>*]:co-w-fit">
        <Button
          size="xl"
          variant="primary"
          loading={loading}
          disabled={!selectedToken}
          onClick={() => {
            handleConfirm();
          }}
        >
          {LABEL_SELECT_BUTTON}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PickCardModal;
